import React, { useCallback, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Dialog } from "@material-ui/core";
import Signifier from "../../Components/Signifier";
import SortableTable from "../../Components/Table/SortableTable";
import InboundFeedTableCell from "../../Components/Table/InboundFeedTableCell";
import InboundFeedModal from "../../Components/Modal/InboundModals/InboundFeedModal";
import { getInboundFeeds } from "../../Services/API/InboundFeeds";
import axios from "axios";

function FeedsPage(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
      [theme.breakpoints.down("sm")]: {
        position: "unset",
      },
    },
  }));

  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  axios.defaults.headers.common["client"] = props?.clientID;

  const columns = [
    { label: "Name", propName: "feedName" },
    { label: "URL", propName: "feedUrl" },
    { label: "Path", propName: "sourceFileFullPath" },
    { label: "Type", propName: "sourceFileType" },
    { label: "Active", propName: "isActiveString" },
    { label: "Compressed", propName: "isCompressedString" },
  ];

  const loadFeeds = useCallback(() => {
    if (
      props.clientID === null ||
      props.clientID === "" ||
      props.clientID === undefined
    )
      return;
    setLoading(true);
    setError(false);
    return getInboundFeeds(props.clientID)
      .then((response) => {
        for (var i in response) {
          response[i].isActiveString = response[i].isActive ? "Yes" : "No";
          response[i].isCompressedString = response[i].isCompressed
            ? "Yes"
            : "No";
        }
        setData(response);
      })
      .catch((err) => {
        console.error("Failed to load inbound feeds:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [props.clientID]);

  useEffect(() => {
    loadFeeds();
  }, [loadFeeds]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Feed Created"
        error={showError}
      />
      <div className={classes.root}>
        {props.clientID !== null &&
        props.clientID !== "" &&
        props.clientID !== undefined ? (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Button
                  color="primary"
                  style={{
                    color: "white",
                    marginBottom: "15px",
                    marginLeft: "0px",
                  }}
                  type="submit"
                  variant="contained"
                  onClick={() => setOpenModal(true)}
                >
                  Add Feed
                </Button>
              </Grid>
            </Grid>
            <SortableTable
              columns={columns}
              tableData={data}
              rowComponent={InboundFeedTableCell}
              loading={loading}
              error={error}
              onRetry={loadFeeds}
              defaultSortIndex={0}
            />
          </>
        ) : (
          <div className={classes.hint}>
            <span>Select a client</span>
          </div>
        )}
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <InboundFeedModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          clientID={props.clientID}
        />
      </Dialog>
    </>
  );
}

export default FeedsPage;
